import PessoaService from "business/cadastro/pessoa/pessoa/pessoaService"
import { isValidCnpj } from "helper/checker"
import { boolToNumber, jsDateToLuxonString, toJSDate } from "helper/formater"
import { justNumbers } from "helper/parser"
import queryString from "query-string"
import * as yup from "yup"

export default class EmpresaService extends PessoaService {

    title = "Empresas do sistema"
    pluralTitle = "Empresas do sistema"
    url = '/configuracao/empresa'
    frontUrl = '/configuracao/empresa'
    frontUrlList = '/configuracao/empresalist'
    primaryKey = 'codigo_emp'
    ignoredsSchemaConvertions = ['cod_regit_pej', 'cod_regite_pej', 'cod_rati_pej', 'cod_grup_pes', 'cod_catp_pes', 'cod_clap_pes']

    postDTO(data = {}) {

        data.pessoa_juridica.pessoa.tel_cel_pes = justNumbers(data.pessoa_juridica.pessoa.tel_cel_pes)
        data.pessoa_juridica.pessoa.tel_comercial_pes = justNumbers(data.pessoa_juridica.pessoa.tel_comercial_pes)

        return data

    }
    prepareToFront(data = {}) {

        data.ativa_emp = boolToNumber(data.ativa_emp)

        // Garante a presença de pessoa e pessoa_endereco no Novo
        data.pessoa_juridica = data.pessoa_juridica || { pessoa: {} }

        data.pessoa_juridica.cnpj_ativo_pej = boolToNumber(data.pessoa_juridica.cnpj_ativo_pej)
        data.pessoa_juridica.forn_pej = boolToNumber(data.pessoa_juridica.forn_pej)
        data.pessoa_juridica.mva_icms_esp_pej = boolToNumber(data.pessoa_juridica.mva_icms_esp_pej)
        data.pessoa_juridica.conveniado_pej = boolToNumber(data.pessoa_juridica.conveniado_pej)
        data.pessoa_juridica.reter_picocs_pej = boolToNumber(data.pessoa_juridica.reter_picocs_pej)
        data.pessoa_juridica.pessoa.reter_iss_pes = boolToNumber(data.pessoa_juridica.pessoa.reter_iss_pes)
        data.pessoa_juridica.ince_fiscal_pej = boolToNumber(data.pessoa_juridica.ince_fiscal_pej)
        data.pessoa_juridica.ince_cult_pej = boolToNumber(data.pessoa_juridica.ince_cult_pej)

        data.pessoa_juridica.pessoa.pessoa_endereco = data.pessoa_juridica.pessoa?.pessoa_endereco || []
        data.pessoa_juridica.pessoa.cli_atac_pes = data.pessoa_juridica.pessoa.cli_atac_pes || 0
        data.pessoa_juridica.pessoa.blq_venda_ate_pes = toJSDate(data.pessoa_juridica.pessoa.blq_venda_ate_pes)
        data.pessoa_juridica.fundacao_pej = toJSDate(data.pessoa_juridica.fundacao_pej)

        if (data.pessoa_juridica.pessoa?.pessoa_endereco) {
            data.pessoa_juridica.pessoa.pessoa_endereco.forEach(e => {
                e.usa_desde_ende = toJSDate(e.usa_desde_ende)
            })
        }

        return data
    }

    async getById(args = {}) {

        args.includes = args.includes || 'main,pessoa_endereco_tipo'
        return super.getById(args).then((response) => {
            console.log('BACKEND: ', response)
            return response
        })

    }

    prepareToSave({ data }) {

        data.ativa_emp = boolToNumber(data.ativa_emp)

        data.pessoa_juridica.cod_regit_pej = data.pessoa_juridica.cod_regit_pej?.codigo_regit || null
        data.pessoa_juridica.cod_regite_pej = data.pessoa_juridica.cod_regite_pej?.codigo_regit || null
        data.pessoa_juridica.cod_rati_pej = data.pessoa_juridica.cod_rati_pej?.codigo_rati || null

        data.pessoa_juridica.forn_pej = boolToNumber(data.pessoa_juridica.forn_pej)

        data.pessoa_juridica.cnpj_ativo_pej = boolToNumber(data.pessoa_juridica.cnpj_ativo_pej)
        data.pessoa_juridica.mva_icms_esp_pej = boolToNumber(data.pessoa_juridica.mva_icms_esp_pej)
        data.pessoa_juridica.conveniado_pej = boolToNumber(data.pessoa_juridica.conveniado_pej)
        data.pessoa_juridica.reter_picocs_pej = boolToNumber(data.pessoa_juridica.reter_picocs_pej)
        data.pessoa_juridica.pessoa.reter_iss_pes = boolToNumber(data.pessoa_juridica.pessoa.reter_iss_pes)
        data.pessoa_juridica.ince_fiscal_pej = boolToNumber(data.pessoa_juridica.ince_fiscal_pej)
        data.pessoa_juridica.ince_cult_pej = boolToNumber(data.pessoa_juridica.ince_cult_pej)

        data.pessoa_juridica.pessoa.blq_venda_ate_pes = jsDateToLuxonString(data.pessoa_juridica.pessoa.blq_venda_ate_pes)

        data.pessoa_juridica.pessoa.reter_iss_pes = boolToNumber(data.pessoa_juridica.pessoa.reter_iss_pes)
        data.pessoa_juridica.pessoa.cli_atac_pes = boolToNumber(data.pessoa_juridica.pessoa.cli_atac_pes)

        data.pessoa_juridica.pessoa.cod_grup_pes = data.pessoa_juridica.pessoa.cod_grup_pes?.codigo_grup || null
        data.pessoa_juridica.pessoa.cod_catp_pes = data.pessoa_juridica.pessoa.cod_catp_pes?.codigo_catp || null
        data.pessoa_juridica.pessoa.cod_clap_pes = data.pessoa_juridica.pessoa.cod_clap_pes?.codigo_clap || null

        data.pessoa_juridica.pessoa.pessoa_endereco.forEach(e => {
            e.cod_tend_ende = e.cod_tend_ende.codigo_tend
            e.cod_muni_ende = e.cod_muni_ende.codigo_muni
        })

        delete data.meta

        return data

    }

    async listByAutoComplete() {

        const search = { page: 1, perPage: 6, type: 'autocomplete' }

        return await this.list('?' + queryString.stringify(search))

    }

    async getSchema() {

        return super.getSchema().then((data) => {

            if (data.fields.pessoa_juridica.fields.pessoa.fields) {

                data.fields.pessoa_juridica.fields.pessoa.fields.cpf_cnpj_pes = data.fields.pessoa_juridica.fields.pessoa.fields.cpf_cnpj_pes.test('cnpj', 'Cnpj incorreto!', isValidCnpj)
                data.fields.pessoa_juridica.fields.pessoa.fields.pessoa_endereco.innerType.fields.cod_tend_ende = yup.object().typeError('Obrigatório').required('Obrigatório')
                data.fields.pessoa_juridica.fields.pessoa.fields.pessoa_endereco.innerType.fields.cod_muni_ende = yup.object()
                    .test('municipio', 'Inválido', e => e.codigo_muni)
                    .typeError('Obrigatório')
                    .required('Obrigatório')

            }

            return data

        })

    }

}
